import * as actionTypes from "../../constants/actionTypes";
import { PHONE_PICKER_TYPES } from "../../constants/phonePicker";

const defaultPhonePickerState = {
  currentPage: 1,
  currentType: PHONE_PICKER_TYPES.popular
};

const phonePicker = (state = defaultPhonePickerState, action) => {
  switch (action.type) {
    case actionTypes.RESET_PHONE_PICKER:
      return defaultPhonePickerState;
    case actionTypes.UPDATE_PHONE_PICKER:
      return { ...state, ...action.settings };
    default:
      return state;
  }
};

export default phonePicker;
